import {Outlet} from "react-router-dom";
import Footer from "../components/views/public/Footer";
import {Flex} from "@chakra-ui/react";

const MainRouters = () => {
    return <>
            <Flex
                as="main"
                mb="50px" // Zwiększ margines od dołu, aby kontener nie był zasłonięty przez footer
            >
                <Outlet />
            </Flex>
            <Footer />
        </>;
};

export default MainRouters;